<script>
    import { format, differenceInSeconds } from 'date-fns';
    import { czk } from '../../lib/currency';
    import time from '../../state/time';

    export let recording;

    // Format specified date
    function formatDate(date) {
        return format(date, 'D. M. YYYY');
    }

    function formatTime(date) {
        return format(date, 'H:mm');
    }

    function expirationTime(curTime, expTime) {
        let secs = differenceInSeconds(expTime, curTime);

        let texts = [];
        let targetCount = null;

        if (secs < 60) {
            texts = ['vteřina', 'vteřiny', 'vteřin'];

            targetCount = secs;
        } else {
            texts = ['minuta', 'minuty', 'minut'];

            let minutes = Math.floor(secs / 60);
            targetCount = minutes;
        }

        let i = 2;
        if (targetCount == 1) i = 0;
        if (targetCount >= 2 && targetCount <= 4) i = 1;

        return `${targetCount} ${texts[i]}`;
    }
</script>

<style>
    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 10px 10px 0;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e4e4e4;
    }

    .group .text {
        background: #ececec;
        /* flex: 1; */
    }
</style>

<!-- <div>
    <div class="group">
        <span class="caption">Čas do expirace</span>
        <span class="text">{expirationTime($time.now, parse(event.res_expiration))}</span>
    </div>
</div> -->

<div>
    <div class="group">
        <span class="caption">Název nahrávky</span>
        <span class="text">{recording.rec_caption}</span>
    </div>
</div>

<div>
    <div class="group">
        <span class="caption">Nahrávka vytvořena</span>
        <span class="text">{formatDate(recording.rec_created)}</span>
    </div>
    <div class="group">
        <span class="caption">Délka nahrávky</span>
        <span class="text">{Math.round(recording.rec_length / 60)} minut</span>
    </div>
</div>

<div>
    <div class="group">
        <span class="caption">Objednávka vytvořena</span>
        <span class="text">{formatDate(recording.reo_created)}</span>
    </div>
</div>

<div class="group">
    <span class="caption">Celková cena</span>
    <span class="text">{czk(recording.reo_price).format()}</span>
</div>